/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useEffect, useState } from 'react';
// utils
import { url } from 'utils/urls';
// material
import { Radio, ImageUploader } from '@insticator/insticator-ui/dist/material';
import Space from 'material/space/space';
import { SectionGroupV2 } from 'material/expandablesection/v2'
import PreviewConfig from 'material/previewconfig/previewconfig'

// styles
import injectSheet from 'react-jss'
import styles from './imagefallback_styles'
import ArticleCard from 'material/articlecard/articleccard';
import { useDispatch } from 'react-redux';
import { setTrendingNowConfigSectionValid } from 'state/slices/trendingnowv2';


/* ========== ~~~~~~~~~~ TRENDING NOW CONFIG V2: ADVANCED SECTION : IMAGE FALLBACK ~~~~~~~~~~ ========== */
const ImageFallback = injectSheet(styles)((props) => {

  const dispatch = useDispatch()
  const { fallbackImageType, fallbackImageUrl, isSectionOpen, onChange } = props
  const [uploadImagePreview, setUploadImagePreview] = useState('');
  const [customImage, setCustomImage] = useState(null)

  useEffect(() => {
    if(fallbackImageType === 'CUSTOM' && (!fallbackImageUrl && !customImage)) dispatch(setTrendingNowConfigSectionValid({ configName: 'advancedConfig', isValid: false }))
    else dispatch(setTrendingNowConfigSectionValid({ configName: 'advancedConfig', isValid: true }))
  }, [customImage, dispatch, fallbackImageType, fallbackImageUrl])

  useEffect(() => {
    // Reset the image previews
    if(!isSectionOpen) {
      setCustomImage(null)
      setUploadImagePreview('')
    }
  }, [isSectionOpen])

  const handleImageFallbackChange = (newProperty) => {
    const currentProperties = {
      fallbackImageType,
      fallbackImageUrl
    }
    onChange({...currentProperties, ...newProperty})
  }

  const handleUpload = image => {
    const imageUrl = URL.createObjectURL(image)
    setUploadImagePreview(imageUrl)
    setCustomImage(image)
    handleImageFallbackChange({ fallbackImage: image })
  }

  const handleDiscard = () => {
    setUploadImagePreview('')
    setCustomImage(null)
  }

  return (
    <SectionGroupV2 
      indented={true} 
      klass={`imagefallback ${props.classes.imagefallback}`} 
      title={'Image fallback'} 
      description={'Placeholder for articles without images.'}
      rowGap={32} 
      direction={'column'}>
        <Space gap={48}>
          <Space direction={'column'}>
            <Radio 
              isList
              title={`COOL Media logo`}
              checked={fallbackImageType === 'INSTICATOR_LOGO'}
              handleChange={() => handleImageFallbackChange({ fallbackImageType: 'INSTICATOR_LOGO' })}
            />
            <Radio 
              isList
              title={`Custom`}
              checked={fallbackImageType === 'CUSTOM'}
              handleChange={() => handleImageFallbackChange({fallbackImageType: 'CUSTOM'})}
            />
            {fallbackImageType === 'CUSTOM' && (
              <ImageUploader
                supportedFileTypes={["image/jpeg", "image/png"]}
                maxSize={1000}
                imageSrc={uploadImagePreview}
                imgSrc={customImage ? customImage.name : 'No file selected'}
                fileName={customImage ? customImage.name : 'No file selected'}
                uploadImage={(value) => handleUpload(value)}
                discardFile={handleDiscard}
              />
            )}
          </Space>
          <PreviewConfig>
            <ArticleCard 
              title={'Sample article headline from your site'}
              totalComments={100}
              imageSrc={fallbackImageType === 'CUSTOM' ? (uploadImagePreview || fallbackImageUrl) : `${url.image}/2.0/trendingnow/article-image-default.jpg`}
              showLogo={fallbackImageType !== 'CUSTOM'}
            />
          </PreviewConfig>
        </Space>
    </SectionGroupV2>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default ImageFallback;